/**------------------------------------------------------
 * Large Language Models
 * ---------------------
 * Overview of all models: https://platform.openai.com/docs/models
 */
export enum EnumAiModel {
	Gpt4o		= 'gpt-4o',
	Gpt4oMini	= 'gpt-4o-mini',
	Gpt5 		= 'gpt-5',
	Gpt5Mini 	= 'gpt-5-mini',
	Gpt5Nano 	= 'gpt-5-nano',
	Gpt5_1 		= 'gpt-5.1',
	Gpt5_4Mini	= 'gpt-5.4-mini',
	Gpt5_6Luna	= 'gpt-5.6-luna',
	Gpt6Luna	= 'gpt-6-luna',
	Gpt6_1Terra	= 'gpt-6.1-terra'
}


/**------------------------------------------------------
 * Names of the Models
 */
export const AI_MODEL_NAMES: Record<EnumAiModel, IAiModel> = {
	[EnumAiModel.Gpt4o] : {
		model		: EnumAiModel.Gpt4o,
		name		: 'GPT-4o',
		description	: `GPT-4o has the ability to understand text and images. This version offers quicker speed.`
	},
	[EnumAiModel.Gpt4oMini] : {
		model		: EnumAiModel.Gpt4oMini,
		name		: 'GPT-4o Mini',
		description	: `GPT-4o Mini is a streamlined, efficient version of GPT-4, optimized for faster performance with lower resource usage. It retains much of GPT-4's language understanding and generation power, making it ideal for tasks requiring high-quality output in resource-constrained or time-sensitive environments. This compact model provides a practical alternative when the full GPT-4 is unnecessary.`
	},
	[EnumAiModel.Gpt5] : {
		model		: EnumAiModel.Gpt5,
		name		: 'GPT-5',
		description	: `GPT-5 is the latest model with advanced capabilities, including improved reasoning and understanding of complex queries.`
	},
	[EnumAiModel.Gpt5Mini] : {
		model		: EnumAiModel.Gpt5Mini,
		name		: 'GPT-5 Mini',
		description	: `GPT-5 Mini is a smaller, more efficient version of GPT-5, designed for faster response times and lower computational requirements while still delivering high-quality language understanding and generation.`
	},
	[EnumAiModel.Gpt5Nano] : {
		model		: EnumAiModel.Gpt5Nano,
		name		: 'GPT-5 Nano',
		description	: `GPT-5 Nano is an ultra-compact version of GPT-5, optimized for minimal resource usage while maintaining essential language processing capabilities. It is designed for applications that require extremely low latency and resource consumption, making it suitable for edge devices or scenarios where computational power is limited.`
	},
	[EnumAiModel.Gpt5_1] : {
		model		: EnumAiModel.Gpt5_1,
		name		: 'GPT-5.1',
		description	: `GPT-5.1 is an enhanced iteration of GPT-5, featuring refinements in language understanding, generation quality, and efficiency. This version builds upon the strengths of GPT-5, offering improved performance for a wide range of applications while maintaining the advanced capabilities introduced in its predecessor.`
	},
	[EnumAiModel.Gpt5_4Mini] : {
		model		: EnumAiModel.Gpt5_4Mini,
		name		: '5.4-Mini',
		description	: `5.4-Mini is the affordable listing model, optimized for reliable structured output and efficient batch generation.`
	},
	[EnumAiModel.Gpt5_6Luna] : {
		model		: EnumAiModel.Gpt5_6Luna,
		name		: '5.6-Luna',
		description	: `5.6-Luna is the premium listing model, offering stronger image understanding and listing quality.`
	},
	[EnumAiModel.Gpt6Luna] : {
		model		: EnumAiModel.Gpt6Luna,
		name		: '6.0-Luna',
		description	: `6.0-Luna is an efficient listing model with image understanding and structured output for high-volume generation.`
	},
	[EnumAiModel.Gpt6_1Terra] : {
		model		: EnumAiModel.Gpt6_1Terra,
		name		: '6.1-Terra',
		description	: `6.1-Terra supports visual reasoning and clear, natural writing for listing generation.`
	}
};

export interface IAiModel {
	model		: EnumAiModel;
	name		: string;
	description	: string;
}
